<div class="contentContainer">
	<main class="contentContainer-main" role="main">
		<header>
			<h1 i18n="@@contactUs-heading">Contact us</h1>
			<p i18n="@@contactUs-intro">
				We're here to help. The best way to get in touch is to start with Olive, our virtual assistant.
			</p>
		</header>
		<div class="banner-container">
			<ng-template cdkPortalOutlet></ng-template>
		</div>
		<section class="contactUs-olive">
			<div class="contactUs-oliveImage"></div>
			<div>
				<h2 i18n="@@contactUs-olive-heading">Need help fast?</h2>
				<p i18n="@@contactUs-olive-intro">
					Get assistance with your online order, request a refund or report an issue via our chatbot Olive.
				</p>
				<wnz-olive-button></wnz-olive-button>
				<p><sub i18n="@@contactUs-olive-action-sub">Available 24/7</sub></p>
			</div>
		</section>
		<section class="contactUs-contacts">
			<section>
				<cdx-svg-icon name="contact-media" size="extra-large" fill="green"></cdx-svg-icon>
				<div>
					<h4 i18n="@@contactUs-method-media-heading">Media & Government enquiries</h4>
					<p>
						<a
							title="Visit the news and media release page"
							href="https://www.countdown.co.nz/info/news-and-media-releases"
							i18n="@@contactUs-method-media-link"
							[cdxTrackEvent]="{event:trackingEvent.NotificationEvent,type:notificationType.Link, name:'Media & Government enquiries'}"
						>More information</a
						>
					</p>
				</div>
			</section>
			<section>
				<cdx-svg-icon name="contact-supplier" size="extra-large" fill="green"></cdx-svg-icon>
				<div>
					<h4 i18n="@@contactUs-method-supplier-heading">Supplier enquiries</h4>
					<p>
						<a
							title="Visit the supplier website"
							href="https://partnerhub.woolworthsgroup.com.au"
							i18n="@@contactUs-method-supplier-link"
							[cdxTrackEvent]="{event:trackingEvent.NotificationEvent,type:notificationType.Link, name:'Supplier enquiries'}"
						>View details on supplier website</a
						>
					</p>
				</div>
			</section>
			<section>
				<cdx-svg-icon name="contact-career" size="extra-large" fill="green"></cdx-svg-icon>
				<div>
					<h4 i18n="@@contactUs-method-careers-heading">Careers</h4>
					<p>
						<a
							title="Visit the careers page"
							href="https://www.countdown.co.nz/info/careers"
							i18n="@@contactUs-method-careers-link"
							[cdxTrackEvent]="{event:trackingEvent.NotificationEvent,type:notificationType.Link, name:'Careers'}"
						>More information</a
						>
					</p>
					<p i18n="@@contactUs-method-careers-description">
						Find out what it's like to work at Woolworths NZ, search for jobs and more.
					</p>
				</div>
			</section>
			<section>
				<cdx-svg-icon name="contact-scam" size="extra-large" fill="green"></cdx-svg-icon>
				<div>
					<h4 i18n="@@contactUs-method-scams-heading">Online scams</h4>
					<p>
						<a
							title="Visit the scams page"
							href="https://www.countdown.co.nz/about-us/consumer-information/countdown-scam-warnings"
							i18n="@@contactUs-method-scams-link"
							[cdxTrackEvent]="{event:trackingEvent.NotificationEvent,type:notificationType.Link, name:'Online scams'}"
						>View all known scams here</a
						>
					</p>
					<p i18n="@@contactUs-method-scams-description">
						Woolworths will never ask for personal details such as PIN numbers over the phone or online.
					</p>
				</div>
			</section>
			<section>
				<cdx-svg-icon name="contact-physical" size="extra-large" fill="green"></cdx-svg-icon>
				<div>
					<h4 i18n="@@contactUs-method-physical-address-heading">Physical address</h4>
					<p i18n="@@contactUs-method-physical-address-description">
						80 Favona Rd<br />Mangere<br />Manukau 2024
					</p>
				</div>
			</section>
			<section>
				<cdx-svg-icon name="contact-postal" size="extra-large" fill="green"></cdx-svg-icon>
				<div>
					<h4 i18n="@@contactUs-method-postal-address-heading">Postal address</h4>
					<p i18n="@@contactUs-method-postal-address-description">
						Woolworths New Zealand Limited<br />Private Bag 93306<br />Otahuhu<br />Manukau
					</p>
				</div>
			</section>
		</section>
		<section class="contactUs-stillStuck" id="contactUs-stillStuck">
			<p i18n="@@contactUs-footer-heading">
				Still stuck? Please give us a call on this number and we can help you out.
			</p>
			<a
				title="Dial 0800 40 40 40"
				href="tel:0800404040"
				[cdxTrackEvent]="{event:trackingEvent.NotificationEvent,type:notificationType.Link, name:'ccPhoneNumber'}"
			>0800 40 40 40</a
			>
		</section>
	</main>
</div>
